window.__preaLoadStyle = window.__preaLoadStyle || function (href, id) {
        if (!href) return;
        if (id && document.getElementById(id)) return;
        if (document.querySelector('link[href="' + href + '"]')) return;

        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        if (id) link.id = id;
        document.head.appendChild(link);
      };

      window.__preaLoadStyles = window.__preaLoadStyles || function (styles) {
        (styles || []).forEach(function (style) {
          window.__preaLoadStyle(style.href, style.id);
        });
      };

      window.__preaLazyStylesOnIntent = window.__preaLazyStylesOnIntent || function (selector, styles) {
        var loaded = false;

        function load() {
          if (loaded) return;
          loaded = true;
          window.__preaLoadStyles(styles);
        }

        function onIntent(event) {
          var target = event.target;
          if (!target || !target.closest || !target.closest(selector)) return;
          load();
        }

        document.addEventListener('pointerdown', onIntent, { capture: true, passive: true });
        document.addEventListener('focusin', onIntent, { capture: true });
        document.addEventListener('mouseover', onIntent, { capture: true, passive: true });

        return load;
      };

      window.__preaLazyStyleOnVisible = window.__preaLazyStyleOnVisible || function (selector, href, id, rootMargin) {
        var loaded = false;

        function load() {
          if (loaded) return;
          loaded = true;
          window.__preaLoadStyle(href, id);
        }

        function observe() {
          var target = document.querySelector(selector);
          if (!target) return;

          if (!('IntersectionObserver' in window)) {
            load();
            return;
          }

          var observer = new IntersectionObserver(function (entries) {
            if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
            observer.disconnect();
            load();
          }, { rootMargin: rootMargin || '900px 0px' });

          observer.observe(target);
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', observe, { once: true });
        } else {
          observe();
        }

        return load;
      };

      window.__preaLoadScript = window.__preaLoadScript || function (src, id) {
        if (!src) return Promise.resolve();

        var existing = (id && document.getElementById(id)) || document.querySelector('script[src="' + src + '"]');
        if (existing) {
          if (existing.dataset.preaLoaded === 'true') return Promise.resolve();
          return new Promise(function (resolve, reject) {
            existing.addEventListener('load', resolve, { once: true });
            existing.addEventListener('error', reject, { once: true });
          });
        }

        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          script.src = src;
          script.defer = true;
          if (id) script.id = id;
          script.onload = function () {
            script.dataset.preaLoaded = 'true';
            resolve();
          };
          script.onerror = reject;
          document.head.appendChild(script);
        });
      };

      window.__preaEnsureEmbla = window.__preaEnsureEmbla || function () {
        if (typeof window.EmblaCarousel === 'function') return Promise.resolve(window.EmblaCarousel);

        return window
          .__preaLoadScript('' + (window.__preaThemeAssets && window.__preaThemeAssets.emblaCarousel) + '', 'prea-embla-carousel')
          .then(function () {
            return window.EmblaCarousel;
          });
      };

      // Delay non-critical section CSS until the section is close enough to
      // the viewport without competing with the LCP image during initial load.
      (function () {
        var selector = 'link[data-prea-lazy-stylesheet]';
        var observedLinks = new WeakSet();
        var observer = null;
        var mobileMedia = window.matchMedia('(max-width: 749px)');

        function markTargetReady(target) {
          if (!target) return;

          var links = target.__preaLazyStylesheets || [];
          var isReady = links.length > 0 && links.every(function (link) {
            return link.dataset.preaStylesheetState === 'loaded' ||
              link.dataset.preaStylesheetState === 'error';
          });

          if (isReady) target.classList.add('prea-styles-ready');
        }

        function finishStylesheet(link, state) {
          link.dataset.preaStylesheetState = state;

          if (state === 'loaded') {
            link.media = 'all';
          }

          link.removeAttribute('data-href');
          link.removeAttribute('data-prea-lazy-stylesheet');

          window.requestAnimationFrame(function () {
            markTargetReady(link.__preaLazyStylesheetTarget);
          });
        }

        function applyStylesheet(link) {
          if (!link || link.dataset.preaStylesheetRequested === 'true') return;

          var href = link.dataset.href;
          if (!href) return;

          link.dataset.preaStylesheetRequested = 'true';
          link.addEventListener('load', function () {
            finishStylesheet(link, 'loaded');
          }, { once: true });
          link.addEventListener('error', function () {
            finishStylesheet(link, 'error');
          }, { once: true });
          link.href = href;
        }

        function ensureObserver() {
          if (observer || !('IntersectionObserver' in window)) return observer;

          observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;

              var links = entry.target.__preaLazyStylesheets || [];
              links.forEach(applyStylesheet);
              observer.unobserve(entry.target);
            });
          }, { rootMargin: '900px 0px' });

          return observer;
        }

        function observeLink(link) {
          if (!link || observedLinks.has(link)) return;
          if (link.hasAttribute('data-prea-mobile-only') && !mobileMedia.matches) return;
          observedLinks.add(link);

          if (!('IntersectionObserver' in window)) {
            applyStylesheet(link);
            return;
          }

          var target = link.closest('.shopify-section') || link.parentElement;
          if (!target) {
            applyStylesheet(link);
            return;
          }

          target.__preaLazyStylesheets = target.__preaLazyStylesheets || [];
          target.__preaLazyStylesheets.push(link);
          link.__preaLazyStylesheetTarget = target;
          ensureObserver().observe(target);
        }

        function scan(root) {
          if (!root) return;
          if (root.matches && root.matches(selector)) observeLink(root);
          if (root.querySelectorAll) root.querySelectorAll(selector).forEach(observeLink);
        }

        function init() {
          scan(document);
          document.addEventListener('shopify:section:load', function (event) {
            scan(event.target);
          });

          var onViewportChange = function (event) {
            if (event.matches) scan(document);
          };

          if (mobileMedia.addEventListener) {
            mobileMedia.addEventListener('change', onViewportChange);
          } else if (mobileMedia.addListener) {
            mobileMedia.addListener(onViewportChange);
          }

        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init, { once: true });
        } else {
          init();
        }
      })();

      // Product-card alternate images are visual hover affordances. Keeping
      // their real URLs in data attributes avoids downloading them on touch
      // devices or for cards the customer never explores.
      (function () {
        var imageSelector = 'img[data-prea-secondary-src]';
        var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

        function hydrate(card) {
          if (!card || !card.querySelector) return;

          var image = card.querySelector(imageSelector);
          if (!image || image.dataset.preaSecondaryRequested === 'true') return;

          image.dataset.preaSecondaryRequested = 'true';
          image.addEventListener('load', function () {
            var media = image.closest('.media--hover-effect');
            if (media) media.classList.remove('prea-secondary-pending');
            image.removeAttribute('data-prea-secondary-src');
            image.removeAttribute('data-prea-secondary-srcset');
          }, { once: true });

          if (image.dataset.preaSecondarySrcset) {
            image.srcset = image.dataset.preaSecondarySrcset;
          }
          image.src = image.dataset.preaSecondarySrc;
        }

        function onPointerIntent(event) {
          if (!hoverQuery.matches) return;
          hydrate(event.target && event.target.closest && event.target.closest('.prea-product-card'));
        }

        function onFocusIntent(event) {
          if (!hoverQuery.matches) return;
          hydrate(event.target && event.target.closest && event.target.closest('.prea-product-card'));
        }

        document.addEventListener('pointerover', onPointerIntent, { capture: true, passive: true });
        document.addEventListener('focusin', onFocusIntent, { capture: true });
      })();

      // Native lazy-loading safety net for rich-text and app-injected images.
      // Theme-owned LCP images declare eager/high priority in their Liquid markup.
      (function () {
        function prepareImage(image) {
          if (!image || image.nodeName !== 'IMG' || image.hasAttribute('loading')) return;
          image.loading = 'lazy';
          if (!image.hasAttribute('decoding')) image.decoding = 'async';
        }

        function prepareImages(root) {
          if (!root) return;
          if (root.nodeName === 'IMG') prepareImage(root);
          if (root.querySelectorAll) {
            root.querySelectorAll('img:not([loading])').forEach(prepareImage);
          }
        }

        function initMediaLoading() {
          prepareImages(document);
          if (!('MutationObserver' in window) || !document.body) return;

          new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              mutation.addedNodes.forEach(prepareImages);
            });
          }).observe(document.body, { childList: true, subtree: true });
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initMediaLoading, { once: true });
        } else {
          initMediaLoading();
        }
      })();

